import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mobileOverlay', 'mobileSidebar']

  openMobile() {
    this.mobileOverlayTarget.classList.remove('hidden')
    this.mobileSidebarTarget.classList.remove('-translate-x-full')
    document.body.classList.add('overflow-hidden')
  }

  closeMobile() {
    this.mobileOverlayTarget.classList.add('hidden')
    this.mobileSidebarTarget.classList.add('-translate-x-full')
    document.body.classList.remove('overflow-hidden')
  }
}
